import { fetchCohort, fetchCohorts } from "../../services";

export const cohortsQuery = () => ({
	queryKey: ["cohorts"],
	queryFn: () => fetchCohorts(),
	meta: {
		errorMessage: "There was an error getting the cohorts.",
	},
});

export const cohortQuery = (cohortID: string) => ({
	queryKey: ["cohort", cohortID],
	queryFn: () => fetchCohort(cohortID),
	meta: {
		errorMessage: "There was an error getting the cohort.",
	},
});
